import React, { useState, useEffect } from 'react'
import { useTbViewStore, useAppEx } from '@vt/hooks'
import { Loading, Toast } from '@ow/comps'
import { Modal, Button, useMantineTheme } from '@mantine/core'
import { pick } from 'lodash-es'
import {
  bindStandard,
  unbindStandard,
  fetchBindTbs,
} from '@vt/apis/lib-ex/v2/standard'
import { FiledsEditor } from '@ow/ditto-editor'
import { fetchTableData } from '@vt/apis/lib-ex/v2/tables'
import { updateTable, destoryField } from '@vt/apis/lib-ex/v2/tables-def'
// deleteField
import EmptyWithTbSelect from './emptyWithTbSelect'
import { useBindStore } from './BindProvider'

export const allowedFieldType = ['text', 'dropSelect', 'number', 'media']

const typeFilter = (e) => {
  return (
    e.slug.includes('bind_standard_') ||
    e.group === 'system' ||
    e.type === 'lookup' ||
    e.type === 'area' ||
    e.slug === 'appId' ||
    e.slug.includes('_text') ||
    e.slug.includes('_otherSelect') ||
    e.slug.includes('_otherSelects')
  )
}

/**
 * 列表排序
 * @param {array} list 排序的列表
 * @param {number} startIndex 排序前的索引
 * @param {number} endIndex 排序后的索引
 * @returns
 */
const reorderList = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

// 过滤额外绑定字段，系统字段，关联字段
export const handleFields = (tbItem) => {
  if (!tbItem) {
    return null
  }
  return tbItem.fields.filter((e) => !typeFilter(e))
}

// 字段绑定编辑器
const FieldBindEditor = () => {
  const { clickedInfo, ditto, selectedIds, setClickedInfo } = useTbViewStore(
    (state) =>
      pick(state, ['clickedInfo', 'ditto', 'selectedIds', 'setClickedInfo'])
  )

  const { setBindTbId } = useBindStore((state) => pick(state, ['setBindTbId']))
  const { clickedId = null, multiSelect = false } = clickedInfo
  const theme = useMantineTheme()
  const { updateTbs, tbsRaw: tbs, appId } = useAppEx()
  const [tbId, setTbId] = useState()
  const [fieldList, setFieldList] = useState(handleFields(tbs[tbId]) || [])
  const [currentBindIndex, setCurrentBindIndex] = useState()
  // hasBindTbs will be true/false or null
  const [hasBindTbs, setHasBindTbs] = useState(null)
  const [hasBindData, setHasBindData] = useState(false)
  const [bindTip, setBindTip] = useState(null)
  // 弹框控制
  const [opened, setOpened] = useState(false)
  // 弹框内容
  const [modalContent, setModalContent] = useState({ text: '', botComps: null })
  // 是否有修改内容，为 true 是有修改内容，需要保存
  const [needSave, setNeedSave] = useState({ isDirty: false, isShift: false })
  const [curBindMap, setCurBindMap] = useState({})

  // 定位当前绑定索引
  const handleBindIndex = () => {
    const bindValue = ditto.getBindSlug(tbId, clickedId)
    if (bindValue && tbId) {
      const bindIndex = fieldList.findIndex(
        (e) => e.slug === bindValue.bindSlug
      )
      setCurrentBindIndex(bindIndex)
    }
  }

  /**
   * 判断当前指标是否已经有数据，如果已有，不能取消/切换绑定
   * @param {*} tableId
   * @returns
   */
  const checkIfHasData = (tableId) => {
    if (!clickedId) {
      setHasBindData(false)
    }
    return fetchTableData(appId, tableId || tbId, {}, {}).then((res) => {
      // 如果任何一条数据的bind_standard_{objectId}有值（非空），则表示有数据
      const targetKey = `bind_standard_${clickedId}`
      const data = res.tbData.find((e) => {
        return !!e[targetKey]
      })
      setHasBindData(!!data)
    })
  }

  /**
   * 检查是否绑定了表单
   * @returns {boolean} 是否绑定了表单
   */
  const checkIfHasBindTbs = () => {
    return fetchBindTbs(appId, clickedId).then((res) => {
      if (res && Array.isArray(res) && res.length > 0) {
        setTbId(res[0])
        setBindTbId(res[0])
        checkIfHasData(res[0])
        return true
      }
      setHasBindData(false)
      return false
    })
  }

  /**
   * 新建字段
   * @param {object} field 当前所需新建的字段模板对象
   * @param {function} onChangeFieldIndex 修改文件索引的回调函数
   */
  const onCreateField = (newField, onChangeFieldIndex) => {
    updateTable(appId, tbId, {
      tbNodes: tbs[tbId].fields.concat(newField),
    }).then(() => {
      updateTbs()
      const newList = fieldList.concat(newField)
      onChangeFieldIndex(newList.length - 1)
      setNeedSave({ isDirty: false, isShift: false })
      Toast.success({
        position: 'center center',
        title: '新建成功',
        description: `新建【${newField.title}】成功`,
      })
    })
  }

  /**
   * 更新保存字段
   * @param {object} field 当前所需保存的字段对象
   * @param {number} curFieldIndex 当前保存对象在列表中的索引
   */
  const onSaveField = (field, curFieldIndex) => {
    const updateIndex = tbs[tbId].fields.findIndex(
      (e) => e.slug === handleFields(tbs[tbId])[curFieldIndex].slug
    )
    // 这里的判断 handleFields(tbs[tbId])[curFieldIndex].slug之所以用这个，是因为切换类型后找不到原来的对象了，index会成为-1，保存会改其他的数据而不是它本身
    // const updateIndex = tbs[tbId].fields.findIndex((e) => e.slug === field.slug)
    const arr = [...tbs[tbId].fields]
    arr.splice(updateIndex, 1, field)

    // const finalArr = arr.map((v) => {
    //   if (v.slug.includes('_otherSelect')) {
    //     return omit(v, ['selfRefSlug', 'ownViewDef', 'isBindStandard'])
    //   }
    //   return v
    // })

    updateTable(appId, tbId, { tbNodes: arr }).then(() => {
      updateTbs()
      setNeedSave({ isDirty: false, isShift: false })
      Toast.success({
        position: 'center center',
        title: '操作成功',
        description: `保存【${field.title}】成功`,
      })
    })
  }

  /**
   * 删除字段
   * @param {object} field 当前所需删除的字段对象
   * @param {function} onChangeFieldIndex 修改文件索引的回调函数
   */
  const onDeleteField = (field, onChangeFieldIndex) => {
    const newList = tbs[tbId].fields.filter((e) => e.slug !== field.slug)

    destoryField(appId, tbId, { tbNodes: newList }).then(() => {
      updateTbs()
      onChangeFieldIndex(fieldList.length - 2)
      Toast.success({
        position: 'center center',
        title: '操作成功',
        description: `删除【${field.title}】成功`,
      })
    })
  }

  // 显示删除二级提示，判断当前使用那种处理方式：有data时隐藏字段，无data时删除字段
  const onShowDeleteModal = (field, curFieldIndex, onChangeFieldIndex) => {
    const bindMapVals = Object.values(curBindMap).map((i) => i.bindSlug)
    const hasData = bindMapVals.indexOf(fieldList[curFieldIndex].slug) > -1

    const checkHandle = () => {
      return hasData
        ? onSaveField({ ...field, hidden: true }, curFieldIndex)
        : onDeleteField(field, onChangeFieldIndex)
    }

    // fetchTableData(appId, tbId, {}, {}).then((res) => {
    //   const data = res.tbData.find((e) => e[field.slug])
    setModalContent({
      text: hasData
        ? `该字段已经存在实际数据，不可以删除，是否要在新增/编辑记录时隐藏该字段？`
        : `是否确认在表单 【${tbs[tbId].tbName}】 中删除 【${field.title}】 字段 ？`,
      handleComp: (
        <div className="flex justify-end items-center w-full mt-4">
          <Button
            variant="outline"
            style={{
              marginLeft: '10px',
              color: '#191919',
              borderColor: '#DCDCDC',
              width: '60px',
              height: '32px',
              fontWeight: 'normal',
              padding: '0',
            }}
            onClick={() => {
              setOpened(false)
            }}
          >
            取消
          </Button>
          <Button
            variant="outline"
            style={{
              marginLeft: '10px',
              color: 'white',
              width: '60px',
              backgroundColor: '#0152D9',
              height: '32px',
              fontWeight: 'normal',
              padding: '0',
            }}
            onClick={() => {
              checkHandle()
              setOpened(false)
            }}
          >
            确定
          </Button>
        </div>
      ),
    })
    setOpened(true)
    // })
  }

  const openAlert = (content) => {
    setModalContent({
      text: content,
      handleComp: (
        <div className="flex justify-end items-center w-full mt-4">
          <Button
            variant="outline"
            style={{
              marginLeft: '10px',
              color: 'white',
              width: '60px',
              backgroundColor: '#0152D9',
              height: '32px',
              fontWeight: 'normal',
              padding: '0',
            }}
            onClick={() => {
              setOpened(false)
            }}
          >
            确定
          </Button>
        </div>
      ),
    })
    setOpened(true)
  }

  /**
   * 更换字段类型
   * @param {object} newField 新改变的类型
   * @param {number} curFieldIndex 需要改变的索引
   */
  const onChangeType = (newField, curFieldIndex) => {
    const bindMapVals = Object.values(curBindMap).map((i) => i.bindSlug)
    if (bindMapVals.indexOf(fieldList[curFieldIndex].slug) > -1) {
      openAlert('该指标的字段已经存在实际数据，不支持修改类型')
      return
    }
    const [...newFieldList] = fieldList
    newFieldList.splice(curFieldIndex, 1, newField)
    setFieldList(newFieldList)
    setNeedSave({ ...needSave, isShift: true })
  }

  useEffect(() => {
    setFieldList(handleFields(tbs[tbId]))
    const targetBindMap = {}
    Object.values(tbs).forEach((tb) => {
      if (tb.enableStandardBind) {
        const { bindMap } = ditto.getBindMap
          ? ditto.getBindMap(tb.tbId)
          : { bindMap: {} }
        Object.assign(targetBindMap, bindMap)
      }
    })
    // const { bindMap } = ditto.getBindMap
    //   ? ditto.getBindMap(810)
    //   : { bindMap: {} }
    setCurBindMap(targetBindMap)
  }, [tbs, tbId])

  useEffect(() => {
    if (typeof clickedId === 'string') {
      checkIfHasBindTbs().then((res) => {
        setHasBindTbs(res)
        handleBindIndex()
      })
    }
  }, [clickedId])

  useEffect(() => {
    if (typeof clickedId === 'string' && fieldList) {
      handleBindIndex()
    }
  }, [fieldList, tbId])

  useEffect(() => {
    setBindTip(
      multiSelect && (!selectedIds || (selectedIds && selectedIds.length === 0))
        ? '请先勾选指标'
        : null
    )
  }, [selectedIds])

  useEffect(() => {
    if (multiSelect) {
      setCurrentBindIndex(null)
      setHasBindTbs(false)
    } else {
      checkIfHasBindTbs().then((res) => {
        setHasBindTbs(res)
        handleBindIndex()
      })
    }
  }, [multiSelect])

  /**
   * 无绑定时，表单选择回调
   * @param {*} selectedTbId
   */
  const tbSelectHandler = (selectedTbId) => {
    if (typeof selectedTbId === 'number') {
      setTbId(selectedTbId)
      setBindTbId(selectedTbId)
      setHasBindTbs(true)
    }
  }

  const render = () => {
    if (hasBindTbs === null) {
      return <Loading />
    }
    return hasBindTbs ? (
      <>
        <FiledsEditor
          tbId={tbId}
          hasBindData={hasBindData}
          bindTip={bindTip}
          createFieldFilter={allowedFieldType}
          onChangeOrder={(list, startIndex, endIndex, onChangeFieldIndex) => {
            const { isDirty, isShift } = needSave
            if (isDirty || isShift) {
              return
            }
            const newOrderList = reorderList(list, startIndex, endIndex)
            setFieldList(newOrderList)
            const otherFields = tbs[tbId].fields.filter((e) =>
              // e.slug.includes('bind_standard_') ||
              // e.group === 'system' ||
              // e.type === 'lookup'
              typeFilter(e)
            )

            updateTable(appId, tbId, {
              tbNodes: newOrderList.concat(otherFields),
            }).then(() => {
              updateTbs()
              onChangeFieldIndex(endIndex)
            })
          }}
          onDragStart={() => {
            const { isDirty, isShift } = needSave
            if (isDirty || isShift) {
              setModalContent({
                text: '变化字段顺序前请先保存当前修改',
                handleComp: (
                  <div className="flex justify-end items-center w-full mt-4">
                    <Button
                      variant="outline"
                      style={{
                        marginLeft: '10px',
                        color: 'white',
                        width: '60px',
                        backgroundColor: '#0152D9',
                        height: '32px',
                        fontWeight: 'normal',
                        padding: '0',
                      }}
                      onClick={() => {
                        setOpened(false)
                      }}
                    >
                      确定
                    </Button>
                  </div>
                ),
              })
              setOpened(true)
            }
          }}
          currentBindIndex={currentBindIndex}
          fieldList={fieldList}
          onBindFuns={{
            isShowUnBindIcon: () => {
              return typeof clickedId === 'string'
            },
            onItemBind: (item) => {
              // 已存在数据，不允许切换绑定
              if (hasBindData) {
                openAlert('该指标的字段已经存在实际数据，不支持解除绑定')
                return
              }
              if (multiSelect) {
                bindStandard(appId, tbId, item.slug, selectedIds).then(() => {
                  updateTbs()
                  setClickedInfo({
                    ...clickedInfo,
                    multiSelect: false,
                    selectedKeys: [clickedId],
                  })
                  // updateTable(appId, tbId, { tbNodes: tbs[tbId].fields })
                })
              } else {
                bindStandard(appId, tbId, item.slug, [clickedId]).then(() => {
                  updateTbs()
                  // updateTable(appId, tbId, { tbNodes: tbs[tbId].fields })
                })
              }
            },
            onItemUnBind: (item, objectId = clickedId) => {
              if (hasBindData) {
                openAlert('该指标的字段已经存在实际数据，不支持解除绑定')
                return
              }
              unbindStandard(appId, tbId, item.slug, [objectId]).then(() => {
                updateTbs()
              })
            },
          }}
          onCreateField={onCreateField}
          onDeleteField={onShowDeleteModal}
          onSaveField={onSaveField}
          onChangeType={onChangeType}
          onInfoDirty={(isDirty) => {
            setNeedSave({ ...needSave, isDirty })
          }}
        />
        <Modal
          opened={opened}
          overlayColor={
            theme.colorScheme === 'dark'
              ? theme.colors.dark[9]
              : theme.colors.gray[2]
          }
          overlayOpacity={0.55}
          styles={{
            inner: { alignItems: 'center' },
          }}
          onClose={() => setOpened(false)}
          title="提示"
        >
          {modalContent.text}
          {modalContent.handleComp}
        </Modal>
      </>
    ) : (
      <EmptyWithTbSelect tbs={tbs} onTbSelect={tbSelectHandler} />
    )
  }
  return render()
}

export default FieldBindEditor
